import QuestLog from './QuestLog';
export default QuestLog;
